export const EXPORTED_TO_ACOMBA = {
  value: "EXPORTED_TO_ACOMBA",
  key: "invoices.status.exportedToAcomba",
};
export const FAILURE = { value: "FAILURE", key: "invoices.status.failure" };
export const GENERATED = {
  value: "GENERATED",
  key: "invoices.status.generated",
};
export const GENERATING = {
  value: "GENERATING",
  key: "invoices.status.generating",
};
export const NOT_GENERATED = {
  value: "NOT_GENERATED",
  key: "invoices.status.notGenerated",
};
export const REVIEW = {
  value: "REVIEW",
  key: "invoices.status.review",
};
export const TEMPLATE = {
  value: "TEMPLATE",
  key: "invoices.status.template",
};
export const PUBLISHED = {
  value: "PUBLISHED",
  key: "invoices.status.published",
};

export default [
  EXPORTED_TO_ACOMBA,
  FAILURE,
  GENERATED,
  GENERATING,
  NOT_GENERATED,
  REVIEW,
  PUBLISHED,
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/enums/invoiceStatuses.js